import './../../assets/scss/_layout/_webshop-front.scss'

import 'slick-carousel';
import { stripEmojisFromStr } from '../utils/string';
import { initializeVueComponent } from '../utils/vue';

import TgWishcard from './../vue/components/wishcard/TgWishcard.vue';

import '../scss/product22.scss'
import './includes/product-variables'

import Currency from "../utils/Currency";

let forceSubmit = false;
let displayPrice = null;
let doAnimate = true;
let isHome = true;

const cachedConflictingProductgroups = []

/* @todo: refactor into product class */
let product = new function () { };

/**
 * The submit button is disabled server side when the product cannot be combined with the current (punchout) order.
 * In that case it may never be re-enabled from javascript.
 */
const isCombinationBlocked = function () {
    const submitElm = document.getElementById('product_form_submit');

    return submitElm !== null && submitElm.getAttribute('data-combination-blocked') === 'true';
};

const combinationProductsContainer = $('#combination_products_product_container');

product.init = function () {
    this.wishcardElm = null;
    this.upsellInputElm = $('.upsell-checkbox');
    this.cardInputElm = $('#add_card');
    this.personalizationInputElm = $('#add_personalization');
    this.letterInputElm = $('#letter');
    this.productVariationElm = $('#product_variation');
    this.upsellVariationElm = $('.upsell-variation-radio');
    this.selectedUpsellItem = $('#selected-upsell-item');
    this.selectedUpsellItemVariation = $('#selected-upsell-item-variation');

    this.requestAvailableOptionsXhr = null;

    product.bindEvents();

    product.hashRedirection();
    product.togglePersonalizationRequired();
    product.togglePersonalizationPriceDisplay();
    product.toggleSubmitBtn();
    product.initCustomQuantityToggle();
    product.initPopovers();
    product.changeCombinationDetails(combinationProductsContainer.attr('data-init-id'));
    product.initAvailableOptions();
    product.initProductGallery();
    product.placeDescription();
};

// The active item and the hidden variation select are rendered server side, see product/includes/gallery.html.twig
product.initProductGallery = function () {
    const galleryItem = document.querySelectorAll('.product-gallery [data-variation-id]');
    const productVariationSelect = document.getElementById('product_variation');
    const activeClassName = 'product-gallery__item--active';
    const defaultClassName = 'product-gallery__item';

    if (galleryItem.length > 0) {
        galleryItem.forEach((item) => {
            item.addEventListener('click', function (event) {
                productVariationSelect.value = event.currentTarget.getAttribute('data-variation-id');
                productVariationSelect.dispatchEvent(new Event('change'));

                const activeVariation = document.getElementsByClassName(activeClassName)
                if (activeVariation.length > 0) {
                    activeVariation[0].className = defaultClassName
                }

                item.className = activeClassName;
            })
        })
    }
}

product.initCustomQuantityToggle = function () {
    $('#product_form_quantity_select').on('change', function (e) {
        $('#product_form_quantity').val(this.value);
    }).trigger('change');

    $('#quantityselector_toggle').on('click', function (e) {
        e.preventDefault();
        $('#product_form_quantity_select').parent('span').toggleClass('form-select-wrapper');
        $('#product_form_quantity_select,#product_form_quantity').toggleClass('hidden');

        if (this.textContent == 'Annuleren') {
            this.textContent = 'Ander aantal';
            $('#product_form_quantity').val($('#product_form_quantity_select').val());
        } else {
            this.textContent = 'Annuleren';
        }

    });
};

product.initPopovers = function () {
    $('[data-toggle="popover"]').each(function (i, elm) {
        new Popover(elm);
    });
};

product.hashRedirection = () => {
    let variationHash = parseInt(location.hash.slice(1));

    if (isNaN(variationHash)) {
        return;
    }

    let productVariations = $('#product_variation option').map(function () {
        let val = $(this).val();
        if (val !== '') {
            return parseInt(val);
        }
    }).get();

    let hasVariationHash = productVariations.indexOf(variationHash) >= 0;

    if (hasVariationHash) {
        history.replaceState(null, null, location.origin + location.pathname);

        const selector = $(`[data-variation-id='${variationHash}'] .btn-product-selection`);
        if (selector.length) {
            // Three column start
            product.selectProductVariation(selector, false);
        } else {
            // Normal product
            $(`#product_variation option[value="${variationHash}"]`).prop('selected', true);
        }
    }
};

product.checkPersonalizationRequired = function () {
    return product.checkForProductProperty('data-personalization-required');
};

product.hasPersonalization = function () {
    return product.checkForProductProperty('data-personalization');
};

product.canUserPersonalize = function () {
    return product.checkForProductProperty('data-can-user-personalize');
};

product.checkForProductProperty = function (property = '') {
    const productField = $('#product_form_product');
    const variationField = $('#product_variation');
    const selectedOption = variationField.find('option:selected');

    // Check on selected variation
    if (variationField.length > 0 && selectedOption.length > 0) {
        return selectedOption.attr(property) === 'true';
    }

    // If no variation field fallback to product field
    if (variationField.length === 0 && (typeof productField.attr(property) !== 'undefined')
    ) {
        return productField.attr(property) === 'true';
    }

    return false;
};

product.togglePersonalizationRequired = function () {
    const isRequired = product.checkPersonalizationRequired();
    const addPersonalizationField = $('#add_personalization');
    const personalizationField = $('#product_form_personalization_product_id');
    const personalizationOption = $('#personalization_option');
    const hasPersonalization = product.hasPersonalization();

    personalizationOption.removeClass('hidden');

    if (parseInt(personalizationField.val()) > 0 && hasPersonalization) {
        if (isRequired) {
            addPersonalizationField.prop('checked', true).prop('required', true);
        } else {
            addPersonalizationField.removeAttr('required');
        }
    } else {
        // If there is no personalization product hide option.
        addPersonalizationField.prop('checked', false).removeAttr('required');
        personalizationOption.addClass('hidden');
    }
};

product.toggleSubmitBtn = function () {
    const addPersonalizationField = $('#add_personalization');
    const submitBtn = $('button#product_form_submit');
    const personalizationElm = $('#product_form_personalization_product_id');
    const canUserPersonalize = this.canUserPersonalize();

    if (
        addPersonalizationField.prop('checked')
        && parseInt(personalizationElm.val()) > 0
        && canUserPersonalize === true
    ) {
        submitBtn.text(submitBtn.data('label-create-design'));
    } else {
        submitBtn.text(submitBtn.data('label-default'));
    }
};

product.toggleVariationPersonalizationPrice = function (selectedOption) {
    const personalizationElm = $('#product_form_personalization_product_id');
    const personalizationId = selectedOption.attr('data-personalization-product-id');
    const personalizationPrice = selectedOption.attr('data-personalization-product-price');
    const personalizationPriceElm = $('#personalization_price');

    if (personalizationElm.length === 1) {
        personalizationElm.val(personalizationId);

        if (personalizationPrice) {
            personalizationPriceElm.html(Currency.format(personalizationPrice));
        } else {
            personalizationPriceElm.html('');
        }
    }
};

product.togglePersonalizationPriceDisplay = function () {
    const addPersonalizationField = $('#add_personalization');
    const personalizationPriceField = $('#personalization_price');
    const personalizationRequired = product.checkPersonalizationRequired();
    const personalizationOption = $('#personalization_option');
    const hasPersonalization = product.hasPersonalization();

    personalizationOption.removeClass('hidden');
    if (personalizationRequired === true || hasPersonalization === false) {
        personalizationOption.addClass('hidden');
    }
};

product.toggleSku = function (variationId) {
    const productCarousel = $('.product-carousel');

    let productCarouselItem = null;
    $('.product-sku .variation__sku').removeClass('visible');
    if (variationId) {
        productCarouselItem = productCarousel.find('.carousel-item[data-variation-id=' + variationId + ']');
        $('.variation__sku[data-id="' + variationId + '"]').addClass('visible');
    }

    if (productCarouselItem !== null && productCarouselItem.length > 0) {
        productCarouselItem.find('form').focus();
        productCarouselItem.find('button').focus();

        const label = productCarouselItem.find('.line-checkbox label').first();

        $('#use_combination + label').text(label.data('title'));
        $('#use_combination_price').text(Currency.format(label.data('price')));
    }
};

product.toggleStockIndicator = function (variationId) {
    $('.variation__stock-status').removeClass('visible');
    if (variationId) {
        $('.variation__stock-status[data-id="' + variationId + '"]').addClass('visible');
    }
};

product.toggleVariationPrice = function (selectedOption) {
    let price = selectedOption.attr('data-price');
    const productPrice = $('.product-price');

    productPrice.closest('.price').find('> p:not(.amount)').hide();

    // Save min price
    if (!displayPrice) {
        displayPrice = productPrice.html();
    }

    if (typeof price === 'undefined') {
        price = displayPrice;
        productPrice.closest('.price').find('> p.from-price').show();

        $(this).closest('form').find('#product_form_submit').prop('disabled', true);
    } else {
        productPrice.closest('.price').find('> p.piece-price').show();
        $(this).closest('form').find('#product_form_submit').prop('disabled', isCombinationBlocked());
    }

    productPrice.text(Currency.format(price));
};

product.toggleVariationOrderableQuantities = function (selectedOption) {
    let html = '';
    let formQuantity = $('#product_form_quantity_select');
    let orderableQuantities = selectedOption.attr('data-orderable-quantities');
    if (orderableQuantities) {
        orderableQuantities = orderableQuantities.split(',');
        orderableQuantities.forEach(function (value) {
            html += '<option value="' + value + '"' + (formQuantity.val() === value ? ' selected="selected"' : null) + '>' + value + '</option>';
        });

        formQuantity.html(html);
    }
};

product.toggleVariationImage = function (selectedOption) {
    const variation_image = selectedOption.attr('data-image');
    if (variation_image) {
        product.setMainImage(
            variation_image,
            selectedOption.attr('data-image-srcset'),
            selectedOption.attr('data-image-avif-srcset'),
        );
        $('.foto-thumbs .thumb').removeClass('active');
        $('.foto-thumbs .fa').removeClass('active');
        $('.foto-thumbs .thumb:first-child .fa').addClass('active');
    }
};

product.changeCombinationDetails = function (productId) {
    if (combinationProductsContainer.length > 0 && productId) {
        $.ajax({
            url: combinationProductsContainer.attr('data-combination-info-path'),
            method: 'POST',
            data: {
                product: productId
            }
        }).then((result) => {
            combinationProductsContainer.html(result);
        });
    }
};

product.initProductCarousel = function (size) {
    const productCarousel = $('.product-carousel');

    if (productCarousel.hasClass('slick-slider')) {
        productCarousel.slick('unslick');
    }

    if (size > 768) {
        return false;
    }

    function setSlickNavLabels(sliderElm, currentSlideElm) {
        const prevSlideElm = currentSlideElm.prev();
        const nextSlideElm = currentSlideElm.next();
        const prevLabel = prevSlideElm.find('.carousel-item').data('label');
        const nextLabel = nextSlideElm.find('.carousel-item').data('label');

        sliderElm.find('> .slider-nav-prev').text(prevLabel);
        sliderElm.find('> .slider-nav-next').text(nextLabel);
    }

    productCarousel
        .on('init', function (slick) {
            setSlickNavLabels($(slick.delegateTarget), $(slick.delegateTarget).find('.slick-current'));
        })
        .on('afterChange', function (slick) {
            setSlickNavLabels($(slick.delegateTarget), $(slick.delegateTarget).find('.slick-current'));
        })
        ;

    productCarousel.slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 1,
        prevArrow: '<span class="slider-nav-prev"></span>',
        nextArrow: '<span class="slider-nav-next"></span>',
    });
};

product.bindEvents = function () {
    const self = this;
    const productForm = $('#product_form');
    const productVariation = $('#product_variation');
    const submitBtnElm = document.querySelector('.btn-add-to-cart');

    let previousQuantity = 0;

    window.onpageshow = (event) => {
        if (event.persisted) {
            document.getElementById('product_form_submit').disabled = isCombinationBlocked();
        }
    };

    $('.product__description', '#content-product').truncate({
        appendActionsTo: '.product__description',
        minLines: 12,
        openText: trans('label.read_more'),
        closeText: trans('label.collapse')
    });

    window.addEventListener('popstate', function (e) {

        if (e.state === null && location.hash === '') {
            isHome = true;
            product.home();
            return;
        }

        isHome = false;

        let variationId = null;
        if (e.state !== null && e.state.variationId !== undefined) {
            variationId = e.state.variationId;
        }

        if (!variationId && location.hash.length > 0) {
            variationId = parseInt(location.hash.replace('#', ''));
        }

        if (variationId) {
            const selector = `[data-variation-id='${variationId}'] .btn-product-selection`;
            product.selectProductVariation($(selector), false)
        }
    });

    // Disable button after submit.
    productForm.on('submit', function () {
        $('#product_form_submit').attr('disabled', 'disabled');
    });

    $(window).on('resize', function () {
        product.placeDescription()
    });

    $('.foto-thumbs').on('mouseenter', '.thumb', function () {
        product.setThumbnail($(this));
    });

    if (productVariation.length > 0) {
        product.initialVariationId = productVariation.val();
        productVariation.on('change', this.onChangeVariation);
    }

    $('.product-column-view .carousel-item').on('mouseenter', function (e) {
        const variationId = e.currentTarget.dataset.variationId;

        product.toggleSku(variationId);
        product.toggleStockIndicator(variationId);
    });

    $('#add_personalization').on('change', function () {
        product.togglePersonalizationRequired();
        product.togglePersonalizationPriceDisplay();
        product.toggleSubmitBtn();
    });

    self.cardInputElm.on('change', function () {
        const cardAlreadyChecked = $('input[name=radio-card]:checked').length;

        if ($(this).is(':checked')) {
            $(this).closest('.line-checkbox').find('.aantal').show();
            $('.wishcard-container', '#content-product #product-info').removeClass('hidden');

            if (!cardAlreadyChecked) {
                $('input[name=radio-card]:first').attr('checked', true).prop('checked', true).trigger('change');
            }

            if (!self.wishcardElm) {
                initializeVueComponent('#wishcard-app', TgWishcard, {}).then((elm) => {
                    self.wishcardElm = elm
                });
            }
        } else {
            $(this).closest('.line-checkbox').find('.aantal').hide();
            $('.wishcard-container', '#content-product #product-info').addClass('hidden');
        }

        $('#card').trigger('change');
    }).trigger('change');

    $('#add_letter').on('click', function () {
        swal({
            title: trans('letter.add'),
            html: trans('letter.upload_description'),
            type: 'info',
            showCancelButton: true,
            cancelButtonText: trans('modal.cancel'),
            confirmButtonText: trans('letter.add'),
            reverseButtons: true,
        }).then((isConfirm) => {
            if (isConfirm.value === true) {
                $('#letter_holder').toggleClass('hidden').find('#letter').click();
                $(this).hide();
            }
        });
    });

    $('#letter').on('change', function () {
        $('.letter-dropdown').toggle($(this).is(':checked'));
    }).trigger('change');

    $('#product_form_letter_file').on('change', function () {
        $('.upload-status').show();
        $('#letter_upload_icon').addClass('fa-pencil').removeClass('fa-cloud-upload');
        $('.upload-btn-text').html(this.files && this.files.length ? this.files[0].name : '');
    });

    window.addEventListener('wishcard:changed', (e) => {
        const card = e.detail.card;
        const cardPriceElm = $('#card_price');
        const wishcardChoiceLabelElm = document.getElementById('wishcard-choice-label');
        const minCardPrice = cardPriceElm.data('minimum-card-price');

        wishcardChoiceLabelElm.innerText = card.size === 'funeral'
            ? trans('label.add_funeral_card')
            : trans('label.add_card')
            ;

        if (card.price) {
            cardPriceElm.text(Currency.format(card.price));
        } else {
            cardPriceElm.text(Currency.format(minCardPrice));
        }
    })

    // Card is valid and submit button can be enabled.
    window.addEventListener('wishcard:validation:valid', () => {
        if (!isCombinationBlocked()) {
            submitBtnElm.removeAttribute('disabled');
        }
    })

    // Card is invalid and submit button must be disabled
    window.addEventListener('wishcard:validation:invalid', () => {
        submitBtnElm.disabled = true;
    })

    productForm.on('submit', function (e) {
        const personalizationOptionsAvailable = $('.product-options .line-checkbox:visible').length;
        const personalizationOptionsChecked = $('.product-options .line-checkbox:visible input[type=checkbox]:checked').length;

        const productQuantity = $('#product_form_quantity').val();
        const cardOptionChecked = $('.product-options .line-checkbox:visible input[name="add_card"]:checked').length;

        const cardQuantity = $('#form_card_quantity');
        const productName = $('#content-product').hasClass('product-type-simple') ? $('.form-static-select-wrapper', '.soort').text() : $('option:selected', '#product_variation').text();

        const personalizationRequired = product.checkPersonalizationRequired();

        const cardOption = document.querySelector('#add_card');
        let cardText = document.getElementsByName('card_text')[0];
        let cardIsValid = true;
        if (cardText !== undefined) {
            cardIsValid = !cardOptionChecked || (cardOptionChecked && cardText.value !== '')
        }

        const letterOption = document.querySelector('#letter');
        let letterOptionChecked = $('.product-options .line-checkbox:visible input[name="letter"]:checked').length;
        const letterFile = document.querySelector('#product_form_letter_file');
        let letterIsValid = true;
        if (letterFile !== null) {
            letterIsValid = !letterOptionChecked || (letterOptionChecked && letterFile.value !== '');
        }

        const submitButton = document.querySelector('#product_form_submit');

        const personalizationOptionCount = cardOptionChecked || letterOptionChecked || personalizationOptionsChecked;

        if (!cardIsValid) {
            e.preventDefault();

            swal({
                title: trans('product.card_text.empty'),
                html: trans('product.card.type_your_text'),
                type: 'info',
                confirmButtonText: trans('product.card_text.button'),
                showCancelButton: true,
                cancelButtonText: trans('cart.order.card.continue_without'),
                reverseButtons: true,
                useRejections: true // swal7fix
            }).then(() => {
                cardText.focus();
            }, () => {
                cardOption.checked = false;
                cardOption.removeAttribute('checked');
                document.querySelector('.wishcard-container').classList.add('hidden');
                productForm.submit();
            });

            submitButton.removeAttribute('disabled');
        } else if (!letterIsValid) {
            e.preventDefault();

            swal({
                title: trans('checkout.delivery.no_letter_cta_text.html'),
                html: trans('letter.upload'),
                type: 'info',
                confirmButtonText: trans('letter.choose_file'),
                showCancelButton: true,
                cancelButtonText: trans('letter.decline'),
                reverseButtons: true,
                useRejections: true // swal7fix
            }).then(() => {
                letterFile.click();
            }, () => {
                letterOption.checked = false;
                letterOption.removeAttribute('checked');
                document.querySelector('.letter-dropdown').style.display = 'none';
                productForm.submit();
            });

            submitButton.removeAttribute('disabled');
        }

        if (!forceSubmit && personalizationOptionsAvailable >= 1) {
            if (
                personalizationOptionCount === 0
                && !personalizationRequired
                && letterIsValid
            ) {
                e.preventDefault();

                swal({
                    title: trans('modal.title.are_you_sure'),
                    html: trans('cart.product.message.no_personalization'),
                    type: 'question',
                    showCancelButton: true,
                    cancelButtonText: trans('cart.order.card.choose'),
                    confirmButtonText: trans('cart.order.card.continue_without'),
                    reverseButtons: true,
                    useRejections: true // swal7fix
                }).then(() => {
                    forceSubmit = true;
                    productForm.submit();
                    submitButton.setAttribute('disabled', 'disabled');
                }, (dismiss) => {
                    if (dismiss === 'cancel') {
                        $('#add_card').prop('checked', true).attr('checked', true).trigger('change');
                    }
                    submitButton.removeAttribute('disabled');
                });
            } else if (
                cardQuantity.length === 0
                && productQuantity > 1
                && personalizationOptionsChecked > 0
                && letterIsValid
            ) {
                e.preventDefault();

                swal({
                    customClass: 'modal-personalization',
                    title: trans('cart.personalization.message.same').replace('%quantity%', productQuantity),
                    html: trans('cart.product.message.same_personalization_message').replace('%product%', productName),
                    type: 'info',
                    showCancelButton: true,
                    cancelButtonText: trans('modal.cancel'),
                    confirmButtonText: trans('modal.add_to_cart'),
                    reverseButtons: true,
                    useRejections: true // swal7fix
                }).then(() => {
                    forceSubmit = true;
                    submitButton.setAttribute('disabled', 'disabled');
                    productForm.submit();
                }, () => {
                    submitButton.removeAttribute('disabled');
                });
            }
        }
    });

    $('.product-column-view')
        .on('submit', '.product-selection-form', function (e) {
            e.preventDefault();

            const form = $(this);
            const values = form.serializeArray();
            const productVariationid = form.find('input[name=product_variation_id]').val();
            const productForm = $('#product_form');
            const useCombinationField = $('#form_use_combination', productForm);
            const variationField = $('#form_variation', productForm);

            variationField.val(productVariationid).trigger('change');

            useCombinationField.val(0);
            if (values.length > 1) {
                useCombinationField.val(1);
            }

            productForm.submit();
        })
        .on('click', '.btn-product-selection', function (e) {
            e.preventDefault();

            const variationId = $(this).closest('.carousel-item').data('variation-id');

            history.pushState({ variationId: variationId }, null, location.href);

            product.selectProductVariation($(this), true);
        })
        .on('change', '.product-carousel .line-checkbox input[type=checkbox]', function () {
            const elm = $(this);
            const label = elm.next();
            const checked = elm.prop('checked');

            $('.line-checkbox input[type=checkbox]').prop('checked', false);
            elm.prop('checked', checked);

            $('#use_combination').prop('checked', checked);
            $('#use_combination + label').text(label.data('title'));
            $('#use_combination_price').text(Currency.format(label.data('price')));
        })
        ;

    $(window).resize(function () {
        product.initProductCarousel($(window).width());
    }).trigger('resize');

    $('#product_form_quantity').on('change', function () {
        if (previousQuantity === 0) {
            previousQuantity = $(this).val();
        }

        const upsellQuantity = $('.upsell-quantity');
        if (upsellQuantity.length
            && upsellQuantity.attr('data-quantity-mode') === 'loosely_following'
            && previousQuantity === upsellQuantity.val()) {
            upsellQuantity.val($(this).val());
        }

        previousQuantity = $(this).val();
    }).trigger('change');

    $('.upsell-checkbox').on('change', function (e) {
        const productGroupId = e.currentTarget.dataset.productgroupId;
        const upsellId = e.currentTarget.dataset.upsellId;

        if ($(this).hasClass('variation-holder')) {
            const variationContainer = $(this).closest('.upsell-container').find('.variations');

            variationContainer.toggle();

            const inputs = variationContainer.find('input');
            if (variationContainer.is(':hidden')) {
                inputs.prop('checked', false);
            } else if (inputs.length > 0) {
                selectFirstUpsell(inputs.first());
            }
        }
    });

    $('.upsell-variation-radio').on('click', (e) => {
        this.selectedUpsellItemVariation.val(e.currentTarget.value);

        showUpsellProperties($(e.currentTarget));
    });

    const selectFirstUpsell = (input) => {
        // Check first upsell product #WEB-5550
        $(input).prop('checked', true);
        this.selectedUpsellItemVariation.val(input.val());

        // Display the first upsell-variation and hide others for next time we check upsell product #WEB-6172
        const upsellVariations = $(input).parents('.upsell-container').find('.upsell-property');
        $(upsellVariations).hide().first().show();
    }

    function showUpsellProperties(elm) {
        const upsellContainerElm = elm.closest('.upsell-container');
        const variationId = elm.attr('data-variation-id');

        $('.upsell-property').hide();
        $(`.upsell-property[data-variation-id="${variationId}"]`).show();

        upsellContainerElm.find('.upsell_price').html($(this).attr('data-price'));
    }

    // Copy input to hidden inputfields with the same index
    $('.upsell-property input').on('input', (e) => {
        const elm = $(e.target);
        const val = e.target.value;
        const itemIndex = elm.data('index');

        $('.upsell-property input[data-index="' + itemIndex + '"]')
            .val(stripEmojisFromStr(val));
    });

    $('.upsell-property input').on('input', (e) => {
        const input = $(e.target).parent('.property-row').find('.text-counter-current');
        if (input.length !== 1) {
            return;
        }

        $(input).text(e.target.value.length);
    })

    let variation = document.getElementById('product_variation');
    if (variation !== null) {
        this.isInitialChangeEvent = true;
        variation.addEventListener('change', (e) => {
            const variationID = e.target.value;

            // When we change between product variations, make sure the earlier selected choices are not selected anymore
            let upsellContainers = document.querySelectorAll('.upsell-container:not([data-variation-id="' + variationID + '"])');
            upsellContainers.forEach((upsellContainer) => {
                this.resetUpsellContainer(upsellContainer, this);
            });

            this.isInitialChangeEvent = false
        });

        // At page load the upsell variation container is hidden so we need to
        // reset the upsell container in order to display the correct upsell product
        variation.dispatchEvent(new Event('change'));
    }
};

product.selectProductVariation = (elm, animate) => {
    doAnimate = !!animate;

    const carouselElm = elm.closest('.product-carousel');
    const carouselItemElm = elm.closest('.carousel-item');
    const items = carouselElm.find('.carousel-item');
    const productSelectionForm = $('#product-selection-form');
    const variationId = carouselItemElm.data('variation-id');

    items.each(() => {
        const item = $(this);
        const productItem = item.find('> div');

        item.attr('style', 'margin: 0;');
        productItem.width(item.width());
    });

    items.removeClass('active');
    carouselItemElm.addClass('active');
    carouselElm.addClass('animate');

    let animationTimeout = null;
    const animationReadyCallback = () => {
        if (animationTimeout) {
            clearTimeout(animationTimeout);
        }
        carouselElm.addClass('ready');

        productSelectionForm.fadeOut(0).fadeIn(350);
    };

    if (doAnimate) {
        animationTimeout = setTimeout(animationReadyCallback, 350);
    } else {
        animationReadyCallback();
    }

    $('#product_variation').val(variationId).trigger('change');
};

product.home = function () {
    $('.carousel-item').removeClass('active');
    $('.product-carousel').removeClass('animate ready').removeAttr('style');
    $('#product-selection-form').hide();
};

product.setThumbnail = function (element) {
    const thumbnail = $(element).find('img');

    $('.foto-thumbs .thumb').removeClass('active');
    product.setMainImage(
        thumbnail.attr('data-large-src'),
        thumbnail.attr('data-large-srcset'),
        thumbnail.attr('data-large-avif-srcset'),
    );

    $(element).addClass('active');
};

// The main image is a <picture>: the browser picks from the srcsets and ignores src, so all three must be swapped
product.setMainImage = function (src, srcset, avifSrcset) {
    const picture = $('.foto-groot picture');

    picture.find('img.image__main').attr({ src: src, srcset: srcset || src });
    picture.find('source[type="image/avif"]').attr('srcset', avifSrcset || srcset || src);
};

product.toggleUpsell = function (variationId) {
    const upsellContainersElm = $('.upsell-container');
    const upsellVariationContainersElm = $('.upsell-container[data-variation-id="' + variationId + '"]');

    upsellContainersElm.hide();
    upsellVariationContainersElm.show();

    upsellContainersElm.find('input.property-input-field').prop('disabled', true);
    upsellVariationContainersElm.find('input.property-input-field').prop('disabled', false);
};

product.requestAvailableOptions = function (target = null, variationChanged = false) {
    const wishcards = window.wishcards || [];
    const selectedCard = parseInt(document.querySelector('input[name="radio-group-radio--card"]:checked')?.value || (wishcards[0] ? wishcards[0].id : -1));
    const wishcard = (selectedCard && wishcards.find((card) => card.id === selectedCard)) || null;
    const url = $('.product-options').data('list-conflicting-productgroup-url');

    this.upsellProductgroupId = [];
    this.upsellEnabled = false;
    this.upsellInputElm.each(el => {
        const upsellInput = this.upsellInputElm[el];

        if ($(upsellInput).prop('checked') && variationChanged === false) {
            this.upsellEnabled = true;
            this.upsellProductgroupId.push($(upsellInput).data('productgroup-id'));
        }
    });

    this.cardEnabled = this.cardInputElm.prop('checked');
    this.personalizationEnabled = this.personalizationInputElm.prop('checked');
    this.letterEnabled = this.letterInputElm.prop('checked');

    this.cardProductgroupId = wishcard ? wishcard.productGroupId : null;
    this.personalizationProductgroupId = $('#product_variation option:selected').data('personalization-productgroup-id') || null;
    this.letterProductgroupId = this.letterInputElm.data('productgroup-id') || null;

    const ids = [];
    if (this.upsellProductgroupId && this.upsellEnabled) {
        ids.push(this.upsellProductgroupId);
    }

    if (this.cardProductgroupId && this.cardEnabled) {
        ids.push(this.cardProductgroupId);
    }

    if (this.personalizationProductgroupId && this.personalizationEnabled) {
        ids.push(this.personalizationProductgroupId);
    }

    if (this.letterProductgroupId && this.letterEnabled) {
        ids.push(this.letterProductgroupId);
    }

    if (ids.length > 0 && this.requestAvailableOptionsXhr === null) {
        setTimeout(() => {
            this.upsellInputElm.each(index => {
                this.disabledUpsellOption($(this.upsellInputElm[index]), false);
            });

            this.disabledOption(this.cardInputElm, false);
            this.disabledOption(this.letterInputElm, false);
            this.disabledOption(this.personalizationInputElm, false);

            const joinIds = ids.join(',');

            if (cachedConflictingProductgroups[joinIds] !== undefined) {
                this.toggleAvailableOptions(cachedConflictingProductgroups[joinIds], target)
                return;
            }

            this.requestAvailableOptionsXhr = $.ajax({
                url,
                data: {
                    ids: joinIds,
                    excludeOwnProductGroup: true
                },
                success: (conflictingProductgroups) => {
                    cachedConflictingProductgroups[joinIds] = conflictingProductgroups;

                    this.toggleAvailableOptions(conflictingProductgroups, target)
                },
                error: () => {
                    this.toggleAvailableOptions([])
                }
            })
        }, 250);

        return;
    }

    this.toggleAvailableOptions([])
}

product.enableOption = (fieldElm) => {
    fieldElm.removeAttr('disabled');

    fieldElm.closest('.product-options__option').removeClass('product-options__option--disabled');
}

product.disabledOption = (fieldElm, uncheck = true) => {
    if (uncheck === true) {
        fieldElm.prop('checked', false)
    }

    fieldElm.attr('disabled', 'disabled');
    fieldElm.closest('.product-options__option').addClass('product-options__option--disabled');
}

product.enableUpsellOption = (fieldElm) => {
    fieldElm.removeAttr('disabled');

    fieldElm.parents('.upsell-container').removeClass('product-options__option--disabled');
}

product.disabledUpsellOption = (fieldElm, uncheck = true) => {
    if (uncheck === true) {
        fieldElm.prop('checked', false)
    }

    fieldElm.attr('disabled', 'disabled');
    fieldElm.parents('.upsell-container').addClass('product-options__option--disabled');
}

product.inConflictingProductgroups = (id, conflictingProductgroups, elm, target = null) => {
    product.enableOption(elm);

    for (const key in conflictingProductgroups) {
        const conflictingProductgroup = conflictingProductgroups[key];
        if (id === conflictingProductgroup.id) {
            // Do not disable the productgroup we just selected
            if ($(target).attr('data-productgroup-id') !== $(elm).attr('data-productgroup-id') && $(elm).prop('checked') === false) {
                product.disabledOption(elm);
            }
        }
    }

    return false;
}

product.inConflictingUpsellProductgroups = (id, conflictingProductgroups, elm, target = null) => {
    // Enable all upsell products
    const inputsToEnable = $('input.upsell-checkbox');
    inputsToEnable.each(function () {
        product.enableUpsellOption($(this));
    });

    for (const key in conflictingProductgroups) {
        const conflictingProductgroup = conflictingProductgroups[key];
        const inputsToDisable = $('input.upsell-checkbox[data-productgroup-id="' + conflictingProductgroup.id + '"]');

        // Disable upsell products which are in conflict with the one we selected
        inputsToDisable.each(function () {
            // Do not disable the upsell product we just selected
            if ($(target).attr('data-upsell-id') !== $(this).attr('data-upsell-id') && $(this).prop('checked') === false) {
                product.disabledUpsellOption($(this));
            }
        });
    }

    return false;
}

product.toggleAvailableOptions = function (conflictingProductgroups, target = null) {
    const addLetterElm = $('#add_letter');

    this.inConflictingUpsellProductgroups(this.upsellProductgroupId, conflictingProductgroups, this.upsellInputElm, target);
    this.inConflictingProductgroups(this.cardProductgroupId, conflictingProductgroups, this.cardInputElm, target);
    this.inConflictingProductgroups(this.personalizationProductgroupId, conflictingProductgroups, this.personalizationInputElm, target);

    if (this.inConflictingProductgroups(this.letterProductgroupId, conflictingProductgroups, this.letterInputElm, target)) {
        addLetterElm.hide();
    } else {
        if ($('input#letter + label:visible').prev().length === 0) {
            addLetterElm.show();
        }
    }

    this.requestAvailableOptionsXhr = null;
}

product.initAvailableOptions = function () {
    this.productVariationElm.on('change', () => {
        this.requestAvailableOptions(null, true)
    });

    const selectedUpsellItemVal = this.selectedUpsellItem.val();
    const selectedUpsellItemVariationVal = this.selectedUpsellItemVariation.val();

    if (selectedUpsellItemVal && selectedUpsellItemVariationVal) {
        const upsellElm = $('#upsell_' + selectedUpsellItemVal);
        const variationId = upsellElm.parents('.upsell-container').data('variation-id');
        const upsellVariationElm = $(`#variation_${variationId}_upsell_${selectedUpsellItemVariationVal}`);

        upsellElm.change();
        upsellVariationElm.click();
    }

    this.upsellInputElm.on('change', (e) => {
        const upsellChecked = $(e.currentTarget).prop('checked');
        const upsellId = $(e.currentTarget).data('upsell-id');

        this.selectedUpsellItem.val(upsellChecked ? upsellId : '');
        if (!upsellChecked) {
            this.selectedUpsellItemVariation.val('');
        }

        if ($(e.currentTarget).next().is(':visible')) {
            this.requestAvailableOptions(e.currentTarget);
        }
    })

    this.personalizationInputElm.on('change', () => { this.requestAvailableOptions() })
    this.letterInputElm.on('change', () => { this.requestAvailableOptions() })
    this.cardInputElm.on('change', (e) => {
        this.requestAvailableOptions(e.currentTarget)
    })

    // Required to trigger with live event because element is created after initial load.
    $('body').on('change', 'input[name="radio-group-radio--card"]', () => {
        this.requestAvailableOptions()
    })
    this.upsellVariationElm.on('change', (e) => {
        const target = $(e.currentTarget).parents('.upsell-container').find('input[class*="upsell-checkbox"]');
        this.requestAvailableOptions(target)
    });

    this.requestAvailableOptions();
}

product.onChangeVariation = function (e) {
    const selectElm = $(e.currentTarget);
    const selectedOption = selectElm.find('option:selected');
    const variationId = selectedOption.val();

    product.syncVariationInUrl(variationId);
    product.toggleVariationPersonalizationPrice(selectedOption);
    product.toggleVariationImage(selectedOption);
    product.toggleVariationPrice(selectedOption);
    product.toggleVariationOrderableQuantities(selectedOption);
    product.changeCombinationDetails(selectedOption.val());

    product.toggleSku(variationId);
    product.toggleStockIndicator(variationId);
    product.toggleUpsell(variationId);
    product.togglePersonalizationRequired();
    product.togglePersonalizationPriceDisplay();
    product.toggleSubmitBtn();
}

// Keep ?productId in line with the chosen variation, so a reload or shared link opens that variation.
// replaceState: switching formats should not add a history entry per click.
product.syncVariationInUrl = function (variationId) {
    const url = new URL(location.href);
    const urlVariationId = url.searchParams.get('productId');

    // A plain product URL stays clean until the visitor picks another variation than the preselected one
    if (urlVariationId === null && variationId === product.initialVariationId) {
        return;
    }

    if (urlVariationId === variationId) {
        return;
    }

    if (variationId) {
        url.searchParams.set('productId', variationId);
    } else {
        url.searchParams.delete('productId');
    }

    history.replaceState(history.state, '', url);
};

product.resetUpsellContainer = function (upsellContainer, ctx) {
    upsellContainer.querySelector('.upsell-checkbox').checked = false;

    upsellContainer.querySelectorAll('.variations input.upsell-variation-radio:checked').forEach((input) => {
        input.checked = false;
    });

    upsellContainer.querySelectorAll('.variations input').forEach((input) => {
        input.removeAttribute('checked');
    });

    upsellContainer.querySelector('.variations').style.display = 'none';

    if (ctx.isInitialChangeEvent === false) {
        ctx.selectedUpsellItem.val('')
        ctx.selectedUpsellItemVariation.val('')
    }
}

product.placeDescription = function () {
    const onMobile = window.innerWidth < 768
    const productDescription = document.querySelector('.product__description')
    const selector = onMobile ? '.product__form' : '.product__content'

    document.querySelector(selector).append(productDescription)
}

$(function () {
    // Add a delay to retrieve browser remembered values
    setTimeout(() => {
        product.init();
    }, 250);
});
